// テレビ台: 横長で低い
import { Box } from '@react-three/drei'

export default function TVStandNewMesh({ width, height, depth, position, color, isSelected }) {
    const legHeight = height * 0.15
    const legY = position[1] - height / 2 + legHeight / 2
    const bodyY = position[1] + legHeight / 2

    return (
        <group>
            {/* メイン本体 */}
            <Box args={[width, height - legHeight, depth]} position={[0, bodyY, 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 中央の棚スペース */}
            <Box args={[width * 0.5, (height - legHeight) * 0.5, depth * 0.6]} position={[0, bodyY, depth * 0.1]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.5} opacity={0.8} transparent />
            </Box>

            {/* 脚 */}
            {[
                [-width / 2 + width * 0.05, legY, -depth / 2 + depth * 0.1],
                [width / 2 - width * 0.05, legY, -depth / 2 + depth * 0.1],
                [-width / 2 + width * 0.05, legY, depth / 2 - depth * 0.1],
                [width / 2 - width * 0.05, legY, depth / 2 - depth * 0.1],
            ].map((pos, i) => (
                <Box key={i} args={[width * 0.04, legHeight, depth * 0.04]} position={pos}>
                    <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
                </Box>
            ))}

            {/* ワイヤーフレーム - メイン本体 */}
            <Box args={[width, height - legHeight, depth]} position={[0, bodyY, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 中央の棚スペース */}
            <Box args={[width * 0.5, (height - legHeight) * 0.5, depth * 0.6]} position={[0, bodyY, depth * 0.1]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 脚 */}
            {[
                [-width / 2 + width * 0.05, legY, -depth / 2 + depth * 0.1],
                [width / 2 - width * 0.05, legY, -depth / 2 + depth * 0.1],
                [-width / 2 + width * 0.05, legY, depth / 2 - depth * 0.1],
                [width / 2 - width * 0.05, legY, depth / 2 - depth * 0.1],
            ].map((pos, i) => (
                <Box key={`wire-${i}`} args={[width * 0.04, legHeight, depth * 0.04]} position={pos}>
                    <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
                </Box>
            ))}

            {/* 選択時のハイライト */}
            {isSelected && (
                <Box args={[width, height, depth]} position={position}>
                    <meshBasicMaterial
                        color="#fbbf24"
                        wireframe
                        opacity={0.8}
                        transparent
                    />
                </Box>
            )}
        </group>
    )
}
